'use strict';

module.exports = require('./es6/crc16modbus').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crc16_modbus.js
// module id = 642
// module chunks = 0